import { useTranslation } from 'react-i18next';
import { AlertCircle, RotateCcw } from 'lucide-react';
import EngagementCarouselSection from './EngagementCarouselSection';

const EngagementCarouselError = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <EngagementCarouselSection role="alert">
      <div className="flex flex-col items-center justify-center text-center py-8 sm:py-10">
        <AlertCircle
          className="w-10 h-10 text-amber-500 mb-3"
          aria-hidden="true"
        />
        <p className="text-base font-semibold text-gray-800">
          {t(
            'engagement_carousel.error_title',
            "We couldn't load this section"
          )}
        </p>
        <p className="text-sm text-gray-500 mt-1 max-w-sm">
          {t(
            'engagement_carousel.error_subtitle',
            'Check your connection and try again.'
          )}
        </p>

        {typeof onRetry === 'function' && (
          <button
            type="button"
            onClick={onRetry}
            className="
              mt-4 inline-flex items-center gap-1.5
              px-4 py-2 min-h-[44px]
              rounded-lg border border-gray-300 bg-white hover:bg-gray-50
              text-sm font-medium text-gray-800
              transition-colors
              focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40
            "
          >
            <RotateCcw className="w-4 h-4" aria-hidden="true" />
            {t('engagement_carousel.error_retry', 'Try again')}
          </button>
        )}
      </div>
    </EngagementCarouselSection>
  );
};

export default EngagementCarouselError;
